module.exports = __webpack_public_path__ + "img/collection3@2x.d7bece22.png";